module.exports = __webpack_public_path__ + "img/organization.a5a3b2c.svg";